<span class="text-semibold">{{ label }}:&nbsp;</span>
@if (!routerLink) {
<span>{{ value }}</span>
} @if (routerLink) {
<a [routerLink]="routerLink">{{ value }}</a>
}
